import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import routes from './Routes'
import Oxygen from "@/ox";

Vue.config.productionTip = false

Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(Oxygen, {
    clientID: 'e883994c7e2cc782b10a'
});

Vue.mixin({
    computed: {
        isAdmin() {
            let user = this.getCurrentUser();
            return user && user.is_admin === 1;
        },
        currentUser() {
            return this.getCurrentUser();
        }
    },
    methods:{
      getCurrentUser(){
        return this.$ox.session.get('user')
      },
      setCurrentUser(user){
        return this.$ox.session.set('user', user);
      }
    }
});


const router = new VueRouter({
    routes
});

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');
